import { z } from 'zod';

import { getApiInstance, harden, Response, Cache } from '../core';

/**
 * @see {@link https://bitbucket.org/reachmedianetwork/player-api} for the original response object.
 */
const ZodTwitterPost = z.object({
    id: z.string(),
    edit_history_tweet_ids: z.array(z.string()),
    text: z.string(),
    created_at: z.string(),
    handle: z.string(),
    profile_image_url: z.string().nullish(),
    image_url: z.string(),
    mediaUrls: z.array(z.string()),
    mediaIds: z.array(z.string()),
});

/**
 * @see {@link https://bitbucket.org/reachmedianetwork/player-api} for the original response object.
 */
const GetSocialXPostsDataSchema = z.object({
    posts: z.array(ZodTwitterPost),
});

export async function getSocialXPosts(params: {
    numberOfPosts: number;
    profileId: number;
}): Response<z.infer<typeof GetSocialXPostsDataSchema>['posts']> {
    const { api, cacheConfig } = await getApiInstance();
    const urlPath = `social/x/posts/${params.profileId}`;

    cacheConfig(Cache.GetWithFallback, urlPath);

    const response = await api.get(urlPath, {
        params: {
            numberOfPosts: params.numberOfPosts,
        },
    });

    return harden(GetSocialXPostsDataSchema, response.data).posts;
}
